export function useAuthorizationCodeHandler(onCompleted?: () => void, redirect?: string | Ref<string>) {
    const errors = ref<string[]>([]);
    const route = useRoute();
    const auth = useAuth();

    onMounted(async () => {
        try {
            const authCode = route.query['code'];
            if (authCode) await auth.requestToken(authCode.toString(), redirect ? unref(redirect) : '/');
        } catch (error) {
            errors.value = getBadRequestErrorsOrThrow(error);
        }

        const authError = route.query['error'];
        if (authError)
            errors.value = Array.isArray(authError)
                ? authError.map((e) => e?.toString() ?? '').filter(Boolean)
                : [authError];

        onCompleted?.();
    });

    return { errors };
}
